import { generateFaqUrl } from '../utils/replace-token-utils/generate-faq-url';
import { replaceFaqTokens } from '../utils/replace-token-utils/replace-faq-tokens';
var SolutionThirdPartyProductComponentController = (function () {
    function SolutionThirdPartyProductComponentController() {
    }
    SolutionThirdPartyProductComponentController.prototype.$onInit = function () {
        var _this = this;
        var _a, _b, _c;
        var hasSupportPage = !!((_a = this.group) === null || _a === void 0 ? void 0 : _a.supportPageUrl);
        if (hasSupportPage && this.hasProduct()) {
            this.product.bundles.forEach(function (bundle) {
                bundle.protocol.notes = replaceFaqTokens(_this.group.supportPageUrl, _this.group.sku, bundle.protocol.notes, generateFaqUrl);
            });
        }
        this.directBundle = (_b = this.product) === null || _b === void 0 ? void 0 : _b.bundles.filter(function (x) { return x.bundle.length === 0; })[0];
        this.bundles = (_c = this.product) === null || _c === void 0 ? void 0 : _c.bundles.filter(function (x) { return x.bundle.length > 0; });
    };
    SolutionThirdPartyProductComponentController.prototype.accessoriesRecommended = function () {
        var _a;
        return this.hasProduct() && this.hasDirectConnection() && ((_a = this.bundles) === null || _a === void 0 ? void 0 : _a.length) > 0;
    };
    SolutionThirdPartyProductComponentController.prototype.accessoriesRequired = function () {
        var _a;
        return this.hasProduct() && !this.hasDirectConnection() && ((_a = this.bundles) === null || _a === void 0 ? void 0 : _a.length) > 0;
    };
    SolutionThirdPartyProductComponentController.prototype.hasDirectConnection = function () {
        return Boolean(this.directBundle);
    };
    SolutionThirdPartyProductComponentController.prototype.hasDirectConnectionProtocol = function () {
        return this.hasDirectConnection() && Boolean(this.directBundle.protocol);
    };
    SolutionThirdPartyProductComponentController.prototype.hasProduct = function () {
        return Boolean(this.product);
    };
    SolutionThirdPartyProductComponentController.$inject = [];
    return SolutionThirdPartyProductComponentController;
}());
export var SolutionThirdPartyProductComponent = {
    bindings: {
        group: '<',
        product: '<',
        segmentType: '=',
    },
    controller: SolutionThirdPartyProductComponentController,
    templateUrl: 'compatibilityguide/ng-templates/feature/search/solutionthirdpartyproduct',
};
